export const SET_FILTER = 'manageQR/SET_FILTER';
export const QR_LIST_REQUESTING = 'manageQR/QR_LIST_REQUESTING';
export const QR_LIST_SUCCESS = 'manageQR/QR_LIST_SUCCESS';
export const QR_LIST_ERROR = 'manageQR/QR_LIST_ERROR';

export const DISABLED_QR_LIST_REQUESTING =
	'manageQR/DISABLED_QR_LIST_REQUESTING';
export const DISABLED_QR_LIST_SUCCESS = 'manageQR/DISABLED_QR_LIST_SUCCESS';
export const DISABLED_QR_LIST_ERROR = 'manageQR/DISABLED_QR_LIST_ERROR';

export const QR_DETAIL_REQUESTING = 'manageQR/QR_DETAIL_REQUESTING';
export const QR_DETAIL_SUCCESS = 'manageQR/QR_DETAIL_SUCCESS';
export const QR_DETAIL_ERROR = 'manageQR/QR_DETAIL_ERROR';
export const UPDATE_QR_DETAILS = 'manageQR/UPDATE_QR_DETAILS';

export const GET_OTP = 'manageQR/GET_OTP';
export const GET_OTP_SUCCESS = 'manageQR/GET_OTP_SUCCESS';
export const GET_OTP_ERROR = 'manageQR/GET_OTP_ERROR';

export const VERIFY_OTP = 'manageQR/VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'manageQR/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'manageQR/VERIFY_OTP_ERROR';

export const CLEAR_OTP = 'manageQR/CLEAR_OTP';

export const DELETE_NOTIFICATION_RECEIVER =
	'manageQR/DELETE_NOTIFICATION_RECEIVER';
export const DELETE_NOTIFICATION_RECEIVER_SUCCESS =
	'manageQR/DELETE_NOTIFICATION_RECEIVER_SUCCESS';
export const DELETE_NOTIFICATION_RECEIVER_ERROR =
	'manageQR/DELETE_NOTIFICATION_RECEIVER_ERROR';

export const DOWNLOAD_QR = 'manageQR/DOWNLOAD_QR';
export const DOWNLOAD_QR_SUCCESS = 'manageQR/DOWNLOAD_QR_SUCCESS';
export const DOWNLOAD_QR_ERROR = 'manageQR/DOWNLOAD_QR_ERROR';

export const TERMINAL_LIST_REQUESTING = 'manageQR/TERMINAL_LIST_REQUESTING';
export const TOTAL_TERMINAL_LIST_REQUESTING =
	'manageQR/TOTAL_TERMINAL_LIST_REQUESTING';
export const TOTAL_TERMINAL_LIST_SUCCESS =
	'manageQR/TOTAL_TERMINAL_LIST_SUCCESS';
export const TERMINAL_LIST_SUCCESS = 'manageQR/TERMINAL_LIST_SUCCESS';
export const TERMINAL_LIST_ERROR = 'manageQR/TERMINAL_LIST_ERROR';

export const RESET_QR = 'manageQR/RESET';
